import { useTranslation } from 'react-i18next';

export default function NoRecordsMessage() {
  const { t } = useTranslation();
  return (
    <div style={{ padding: '1rem', textAlign: 'center' }}>
      {t('common.noRecords')}
    </div>
  );
}
